const Config = {
    tomviz: {
        logo: "/PlantViz_images/TomViz_logo.svg",
        header: "/PlantViz_images/TomViz_header.svg",
        color: "bg-red-800",
        url: "/tomviz",
        text: "Solanum lycopersicum",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/tomviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=ITAG4&tracks=ITAG_4.0_4.2&loc=chr02:47,352,027..47,358,358"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use the following expression atlases to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    pseudomonas_atlas: {
                        name: "Pseudomonas",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/pseudomonas_atlas"
                    },
                    terpineol_atlas: {
                        name: "Terpineol",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/terpineol_atlas"
                    }
                }
            },
            agg_gcns: {
                title: "Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/leaf"
                    },
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/bud"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/flower"
                    },
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/CI"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/root"
                    },
                    fruit: {
                        name: "fruit",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/agg_gcns/fruit"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    seedling: {
                        name: "seedling",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/seedling"
                    },
                    embryo: {
                        name: "embryo",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/embryo"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/seed"
                    },
                    cellculture: {
                        name: "cellculture",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/cellculture"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/stem"
                    },
                    pollen: {
                        name: "pollen",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/pollen"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/trichomes"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/non_agg_gcns/vasculature"
                    }
                }
            },
            igrns: {
                title: "Inferred GRN App",
                description: "Inferred gene regulatory networks. Noise-filtered output from GENIE3.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/leaf"
                    },
                    fruit: {
                        name: "fruit",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/fruit"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/flower"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/seed"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/igrns/root"
                    }
                }
            },
            grns: {
                title: "rGRN App",
                description: "Reference gene regulatory networks (rGRNs) from organ-specific and condition-independent RNA-seq datsets complemented with gene co-expression and TF-binding predictions on open chromatin sites. Users may obtain lists of regulatory pairs of TF and target genes and visualize subnetworks using specific gene sets.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/grns/leaf"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/grns/flower"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/grns/seed"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/grns/root"
                    },
                    fruit: {
                        name: "fruit",
                        link: "https://plantaeviz.tomsbiolab.com/tomviz/networks/grns/fruit"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/tomviz/exhara"
            },
            DAPBrowse: {
                title: "DAP-Browse App",
                description: "Browse through DAP-Seq data associated to the ITAG4 genome assembly for different transcription factors.",
                image: "/PlantViz_images/Vitviz_apps/DAPBrowse_banner.png",
                link: "http://147.156.206.251/test/?data=mydata%2FTomato&loc=SL4.0ch02%3A35884881..35900800&tracks=DNA%2CMYC2r_peaks%2CMYC2r2_peaks%2CMYC2_peaks%2CChip-MYC2_peaks%2Cannotations%2CHSFA1a_2_peaks%2CHsfA2_peaks%2CHsfA7_peaks%2CMYB21_peaks%2CMYB24_peaks%2CMYB70_peaks&highlight="
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/tomviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4502"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/tomviz/genexplore"
            }
        }
    },
    mulviz: {
        logo: "/PlantViz_images/MorViz_logo.svg",
        header: "/PlantViz_images/MorViz_header.svg",
        color: "bg-purple-800",
        url: "/mulviz",
        text: "Morus alba",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/mulviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=Mal_HE_154X&tracks=Mal_HE_154X_1&loc=Chr8:3,659,604..3,663,337"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use the following expression atlases to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    morus_atlas: {
                        name: "Botrytis stress",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/morus_atlas"
                    },
                    morus_meja_atlas: {
                        name: "MeJA",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/morus_meja_atlas"
                    },
                    fruit_flower_morus_atlas: {
                        name: "Fruit & flower",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/fruit_flower_morus_atlas"
                    }
                }
            },
            agg_gcns: {
                title: "Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/agg_gcns/CI"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    fruit_and_seed: {
                        name: "fruit and seed",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/fruit_and_seed"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/leaf"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/flower"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/stem"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/root"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/vasculature"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/mulviz/networks/non_agg_gcns/seed"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/mulviz/exhara"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/mulviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4500"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/mulviz/genexplore"
            }
        }
    },
    vitviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/VitViz_header.svg",
        color: "bg-vitviz",
        url: "/vitviz",
        text: "Vitis vinifera",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=vitis_vinifera_T2T&tracks=5.1&loc=chr14:27,774,235..27,783,044"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use the following expression atlases to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    Corvina: {
                        name: "cv. 'Corvina'",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/corvina_atlas"
                    },
                    Flower: {
                        name: "Flower development",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/flower_atlas"
                    },
                    Berry: {
                        name: "Berry development",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/berry_atlas"
                    },
                    Circadian: {
                        name: "Circadian Rhythm",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/circadian_rhythm_app"
                    },
                    Botrytis: {
                        name: "Botrytis stress",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/botrytis_atlas"
                    },
                    Hydric: {
                        name: "Hydric stress",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/hydric_atlas"
                    }
                }
            },
            T2T_agg_gcns: {
                title: "T2T Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/agg_gcns/T2T/flower"
                    },
                    berry_without_seed: {
                        name: "berry without seed",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/agg_gcns/T2T/berry_without_seed"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/agg_gcns/T2T/leaf"
                    }
                }
            },
            v3_agg_gcns: {
                title: "v3 Agg GCN App",
                description: "Aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes. Aggregation typically improves network performance but requires larger datasets (Orduña et al. 2023), tissues missing here may be found in non aggregated GCNs.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/agg_gcns/v3/leaf"
                    }
                }
            },
            T2T_non_agg_gcns: {
                title: "T2T Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    hydric_stress_TI: {
                        name: "hydric stress TI",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/hydric_stress_TI"
                    },
                    hydric_stress_shoot_system: {
                        name: "hydric stress shoot system",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/hydric_stress_shoot_system"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/root"
                    },
                    hydric_stress_root: {
                        name: "hydric stress root",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/hydric_stress_root"
                    },
                    hydric_stress_berry: {
                        name: "hydric stress berry",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/hydric_stress_berry"
                    },
                    hydric_stress_leaf: {
                        name: "hydric stress leaf",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/T2T/hydric_stress_leaf"
                    }
                }
            },
            v3_non_agg_gcns: {
                title: "v3 Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/flower"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/root"
                    },
                    tendril: {
                        name: "tendril",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/tendril"
                    },
                    cellculture: {
                        name: "cellculture",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/cellculture"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/vasculature"
                    },
                    wood: {
                        name: "wood",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/wood"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/stem"
                    },
                    berry_pericarp: {
                        name: "berry pericarp",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/berry_pericarp"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/seed"
                    },
                    embryo: {
                        name: "embryo",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/embryo"
                    },
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/non_agg_gcns/v3/bud"
                    }
                }
            },
            v3_igrns: {
                title: "v3 Inferred GRN App",
                description: "Inferred gene regulatory networks. Noise-filtered output from GENIE3.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    berry: {
                        name: "berry",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/berry"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/root"
                    },
                    pericarp: {
                        name: "pericarp",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/pericarp"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/vitviz/networks/igrns/v3/leaf"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/exhara"
            },
            DAPBrowse: {
                title: "DAP-Browse App",
                description: "Browse through DAP-Seq data associated to the PN40024.2 genome assembly for different transcription factors.",
                image: "/PlantViz_images/Vitviz_apps/DAPBrowse_banner.png",
                link: "http://plantaeviz.tomsbiolab.com:8004/vitis"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4503"
            },
            Conversions: {
                title: "Conversions App",
                description: "Convert between V3(V.Cost) and V1 gene ID annotations as well and append gene names and relevant info extracted from the grapevine reference gene catalogue provided as part of <a href='https://grapedia.org/genes/' target='_blank' style='color: blue'>Grapedia</a>.",
                image: "/PlantViz_images/Vitviz_apps/CONVERSIONS_banner.png",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/conversions"
            },
            TransMetaDb: {
                title: "TransMeta Db",
                description: "The Transcriptomics & Metabolomics integrated database (TransMetaDb) can be used to explore the correlation between the expression of a list of genes of interest and different metabolites. For those correctly annotated experiments, there is also the option to integrate different studies, giving rise to more robust correlation analyses.",
                image: "/PlantViz_images/Vitviz_apps/TransMetaDB.png",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/transmetadb"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/vitviz/genexplore"
            }
        }
    },
    araviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/AraViz_header.svg",
        color: "bg-araviz",
        url: "/araviz",
        text: "Arabidopsis thaliana",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/araviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=TAIR10&tracks=Araport11&loc=Chr1:6,051,821..6,058,692"
            },
            atlases: {
                title: "Expression Atlases App",
                description: "Use the following expression atlases to navigate through different transcriptomic datasets (microarray or RNA-Seq) in order to test the expression of your genes across specific tissues and developmental stages.",
                image: "/PlantViz_images/Vitviz_apps/Corvina_Atlas.jpg",
                link: {
                    beta_ionone_botrytis_atlas: {
                        name: "Beta ionone - Botrytis",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/beta_ionone_botrytis_atlas"
                    }
                }
            },
            non_agg_gcns: {
                title: "Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    cellculture: {
                        name: "cellculture",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/cellculture"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/root"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/stem"
                    },
                    vasculature: {
                        name: "vasculature",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/vasculature"
                    },
                    seedling: {
                        name: "seedling",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/seedling"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/flower"
                    },
                    fruit: {
                        name: "fruit",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/fruit"
                    },
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/bud"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/seed"
                    },
                    embryo: {
                        name: "embryo",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/embryo"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/leaf"
                    },
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/araviz/networks/non_agg_gcns/CI"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/araviz/exhara"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/araviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4501"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/araviz/genexplore"
            }
        }
    },
    cannaviz: {
        logo: "/PlantViz_images/VitViz_logo.svg",
        header: "/PlantViz_images/CannaViz_header.svg",
        color: "bg-cannaviz",
        colorText: "text-black-50",
        url: "/cannaviz",
        text: "Cannabis sativa",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences. Individual apps are provided for the following genomes: CBDRx, PurpleKush, and JamaicanLion",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: {
                    cbdrx: {
                        name: "CBDRx",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/catalogue_CBDRx"
                    },
                    purplekush: {
                        name: "Purple Kush",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/catalogue_PK"
                    },
                    jamaicanlion: {
                        name: "Jamaican Lion",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/catalogue_JL"
                    }
                }
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: {
                    PurpleKush: {
                        name: "Purple Kush",
                        link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=PurpleKush&tracks=PurpleKush&loc=Chr1:32,260,842..32,272,273"
                    },
                    CBDRx: {
                        name: "CBDRx",
                        link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=CBDRx&tracks=CBDRx&loc=Chr10:48,416,475..48,422,738"
                    },
                    JamaicanLion: {
                        name: "Jamaican Lion",
                        link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=JamaicanLion&tracks=JamaicanLion&loc=QVPT02000341.1:344,363..350,872"
                    }
                }
            },
            JL_non_agg_gcns: {
                title: "JL Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/root"
                    },
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/bud"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/flower"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/trichomes"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/seed"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/leaf"
                    },
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/JL/CI"
                    }
                }
            },
            PK_non_agg_gcns: {
                title: "PK Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/CI"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/flower"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/leaf"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/seed"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/root"
                    },
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/bud"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/trichomes"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/PK/stem"
                    }
                }
            },
            cbdrx_non_agg_gcns: {
                title: "cbdrx Non agg GCN App",
                description: "Non aggregated gene co-expression networks (GCNs) from tissue-specific and condition-independent RNA-Seq datasets.<br></br>Obtain lists of co-expressed genes for a gene of interest or visualize a subnetwork for a particular set of genes.",
                image: "/PlantViz_images/Vitviz_apps/AggGCNs.png",
                link: {
                    bud: {
                        name: "bud",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/bud"
                    },
                    flower: {
                        name: "flower",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/flower"
                    },
                    CI: {
                        name: "CI",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/CI"
                    },
                    root: {
                        name: "root",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/root"
                    },
                    seed: {
                        name: "seed",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/seed"
                    },
                    trichomes: {
                        name: "trichomes",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/trichomes"
                    },
                    stem: {
                        name: "stem",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/stem"
                    },
                    leaf: {
                        name: "leaf",
                        link: "https://plantaeviz.tomsbiolab.com/cannaviz/networks/non_agg_gcns/cbdrx/leaf"
                    }
                }
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/cannaviz/exhara"
            },
            DAPBrowse: {
                title: "DAP-Browse App",
                description: "Browse through DAP-Seq data associated to the PN40024.2 genome assembly for different transcription factors.",
                image: "/PlantViz_images/Vitviz_apps/DAPBrowse_banner.png",
                link: "http://plantaeviz.tomsbiolab.com:4601/?config=config.json&assembly=PurpleKush&loc=chr01:1..1000"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/cannaviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4504"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/cannaviz/genexplore"
            }
        }
    },
    chlamviz: {
        logo: "/PlantViz_images/ChlamViz_logo.svg",
        header: "/PlantViz_images/ChlamViz_header.svg",
        color: "bg-chlamviz",
        url: "/chlamviz",
        text: "Chlamydomonas reinhardtii",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/chlamviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=Chlre_6.0&tracks=Chlre_6.1&loc=chromosome_01:727,021..762,402"
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/chlamviz/exhara"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/chlamviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4507"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/chlamviz/genexplore"
            }
        }
    },
    prunviz: {
        logo: "/PlantViz_images/PrunViz_logo.svg",
        header: "/PlantViz_images/PrunViz_header.svg",
        color: "bg-prunviz",
        url: "/prunviz",
        text: "Prunus persica",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/prunviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=P.%20persica&tracks=P.%20persica&loc=Pp01:18,647,260..18,673,507"
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/prunviz/exhara"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/prunviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4506"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/prunviz/genexplore"
            }
        }
    },
    strawviz: {
        logo: "/PlantViz_images/StrawViz_logo.svg",
        header: "/PlantViz_images/StrawViz_header.svg",
        color: "bg-strawviz",
        url: "/strawviz",
        text: "Fragaria vesca",
        apps: {
            catalogue: {
                title: "Catalogue Gene Cards",
                description: "Gene Cards focuses information around individual gene ids. This includes curated catalogue gene functions, automatic functional descriptions, potential orthologues, organ-specific gene expression, and fasta formatted sequences.",
                image: "/PlantViz_images/Vitviz_apps/GeneCard.png",
                link: "https://plantaeviz.tomsbiolab.com/strawviz/catalogue"
            },
            jbrowse: {
                title: "JBrowse2",
                description: "Visualize genomic data including genome annotation and RNA-seq expresion. It supports multiple views (e.g., linear, circular, synteny between species).",
                image: "/PlantViz_images/Vitviz_apps/jbrowse2.png",
                link: "https://plantaeviz.tomsbiolab.com/jbrowse/?config=config.json&assembly=F.%20vesca&tracks=F.%20vesca&loc=Fvb1:9,477,628..9,502,302"
            },
            EXHARA: {
                title: "EXHARA App",
                description: "<u>EX</u>pression <u>H</u>eatmaps <u>A</u>cross all SRA <u>R</u>uns <u>A</u>vailable<br><br>Use Exhara to inspect gene expression across all Illumina based RNA-Seq runs available.",
                image: "/PlantViz_images/Vitviz_apps/heatmaps_network.jpg",
                link: "https://plantaeviz.tomsbiolab.com/strawviz/exhara"
            },
            msa: {
                title: "Multiple Sequence Alignment (MSA)",
                description: "Visualize and analyze Multiple Sequence Alignments (MSAs) with interactive tools. Explore sequence conservation, identify patterns, and gain insights into protein families, evolutionary relationships, and functional residues.",
                image: "/PlantViz_images/Vitviz_apps/msa_app.png",
                link: "https://plantaeviz.tomsbiolab.com/strawviz/msa"
            },
            blast: {
                title: "BLAST",
                description: "Perform sequence similarity searches against genes, transcripts, CDSs and proteins using BLAST (Basic Local Alignment Search Tool). This tool allows you to identify homologous sequences and explore gene annotations.",
                image: "/PlantViz_images/Vitviz_apps/chord_diagram.png",
                link: "http://plantaeviz.tomsbiolab.com:4508"
            },
            genexplore: {
                title: "GeneXplore",
                description: "Unlock the power of public transcriptomic data filtering NCBI's Sequence Read Archive (SRA) metadata using a curated ontology by tissue, developmental stage, cultivar, or organism. Visualize the expression levels of multiple genes making complex data analysis simple and insightful.",
                image: "/PlantViz_images/Vitviz_apps/expression_ontology.png",
                link: "https://plantaeviz.tomsbiolab.com/strawviz/genexplore"
            }
        }
    }
}

export default Config;
